/* eslint-disable arrow-body-style */
import React from 'react';
import { TextField, FormControl, FormControlLabel, Checkbox, Button, FormHelperText, IconButton } from '@mui/material';
import RemoveIcon from '@mui/icons-material/Remove';

const AdditionalServicesSection = ({ formik }) => {
  return (
    <>
      <FormControl>
        <FormControlLabel
          control={
            <Checkbox
              name="additional_services_enabled"
              checked={formik.values.additional_services_enabled || false}
              onChange={(e) => {
                formik.setFieldValue('additional_services_enabled', e.target.checked);
                if (!e.target.checked) {
                  formik.setFieldValue('additional_services', []);
                }
              }}
            />
          }
          label="Additional Services"
        />
      </FormControl>

      {formik.values.additional_services_enabled && (
        <>
          <FormControl>
            {formik.values.additional_services.map((service, index) => (
              <div key={index} style={{ display: 'flex', alignItems: 'center', marginBottom: '20px' }}>
                <TextField
                  name={`additional_services[${index}]`}
                  label="Additional Service"
                  fullWidth
                  value={service}
                  onChange={(e) => {
                    const newServiceName = e.target.value;

                    const updatedAdditionalServices = [...formik.values.additional_services];
                    updatedAdditionalServices[index] = newServiceName;
                    formik.setFieldValue('additional_services', updatedAdditionalServices);
                  }}
                />
                <IconButton
                  onClick={() => {
                    const updatedAdditionalServices = formik.values.additional_services.filter((_, i) => i !== index);
                    formik.setFieldValue('additional_services', updatedAdditionalServices);
                  }}
                  aria-label="delete-service"
                >
                  <RemoveIcon />
                </IconButton>
              </div>
            ))}
            <Button
              variant="outlined"
              style={{ height: '50px', width: '190px', color: '#0A9EF2', borderColor: '#0A9EF2' }}
              onClick={() => formik.setFieldValue('additional_services', [...formik.values.additional_services, ''])}
            >
              Add Service
            </Button>
            {formik.touched.additional_services && formik.errors.additional_services && (
              <FormHelperText error>{formik.errors.additional_services}</FormHelperText>
            )}
          </FormControl>
        </>
      )}
    </>
  );
};

export default AdditionalServicesSection;
